import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import { FormControl, FormLabel } from "@mui/material";
import { setIsSeries } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { useDispatch, useSelector } from "react-redux";

const IsSeries = ({ type }) => {
  const dispatch = useDispatch();
  const isSeries = useSelector((state) => state.contentForm.isSeries);
  const handleChange = () => {
    dispatch(setIsSeries(!isSeries));
  };
  return (
    <FormControl>
      <FormLabel component="legend">{type}</FormLabel>
      <Switch
        checked={isSeries}
        onChange={handleChange}
        inputProps={{ "aria-label": "Is Series" }}
      />
    </FormControl>
  );
};

export default IsSeries;
